import type { PackSubmissionDetail } from '@planuze/admin-contracts';
import { VersionDiff } from '@planuze/features-publisher-portal';
import { Card, CardContent, CardHeader, CardTitle } from '@planuze/ui';
import { usePackSubmissionsContent } from '../../content/sections/pack-submissions.js';

/* Diff de campos do manifest da submissão vs a versão anterior (ADR-0475), computado server-side a
   partir dos snapshots. Reusa o VersionDiff (data-driven). `null` = sem versão anterior com snapshot
   (primeira versão / pré-migração) ou snapshot malformado (fail-soft). */

export function ManifestDiffCard({
  manifestDiff,
}: {
  readonly manifestDiff: PackSubmissionDetail['manifestDiff'];
}) {
  const copy = usePackSubmissionsContent();
  if (manifestDiff === null || manifestDiff === undefined) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>{copy.manifestDiffCard.cardTitle}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">{copy.manifestDiffCard.noPriorVersion}</p>
        </CardContent>
      </Card>
    );
  }
  return (
    <Card>
      <CardContent className="pt-6">
        <VersionDiff diff={manifestDiff} labels={copy.manifestDiffCard.labels} />
      </CardContent>
    </Card>
  );
}
